<!-- 
Providers listing page.
-->
<template>
  <div class="home">
    <our-heading 
      :breadcrumbs="breadcrumbs"
      title="Providers"
      user-guide-topic="listing-providers"
    />
    <our-search-bar>
      <our-quick-search 
        slot="quick-search"
        :criteria-mutation="criteriaMutation" 
        :value="quickSearch"
        label="Provider name or code" 
        field="name" 
        field-if-numeric="providerCode" 
        @changed="$refs.listing.refresh()"
      />
      <our-search-button 
        slot="search-button"
        :criteria="criteria" 
        :criteria-mutation="criteriaMutation" 
        :search-filters="searchFilters" 
        title="Search providers"
        @changed="$refs.listing.refresh()"
      />
      <our-saved-searches-menu
        slot="saved-searches-button"
        :criteria="criteria"
        :criteria-mutation="criteriaMutation"
        :clear-criteria-mutation="clearCriteriaMutation"
        module="providers" 
        @selected="$refs.listing.refresh()"
      />
    </our-search-bar>
    <provider-listing ref="listing" @click="openProvider"/>
  </div>
</template>

<script>
import ProviderListing from "@/components/providers/ProviderListing.vue";
import * as mutation from "@/store/providers/mutation-types";
import { getSearchFilters } from "@/store/providers/helpers";

export default {
  name: "Providers",
  components: { ProviderListing },
  data() {
    return {
      showCreateDialog: false,
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA,
      breadcrumbs: [{ text: "Providers" }]
    };
  },
  computed: {
    searchFilters() {
      return getSearchFilters();
    },
    criteria() {
      return this.$store.state.providers.listing.criteria;
    },
    quickSearch() {
      return this.criteria.providerCode && !this.criteria.name ? this.criteria.providerCode : this.criteria.name;
    }
  },
  methods: {
    openProvider(id) {
      this.$router.push(`/providers/${id}`);
    },
    openNewProvider(provider) {
      this.openProvider(provider.id);
    }
  }
};
</script>
